import { createContext } from 'react';

import { Options } from './types';

export default createContext<{
  enableScrollbar: (handlerId: string) => (options?: Options) => void;
  disableScrollbar: (handlerId: string) => (options?: Options) => void;
}>({
  enableScrollbar: () => () => {},
  disableScrollbar: () => () => {},
});
